export const handleBlogPubForm = (data, { title, content }) => {
  let postType = data.pushType
  if (postType === 2 && data.interval) postType = 3
  if (!data.time) postType = 1
  return {
    sourceType: 2,
    type: data.productId,
    blogType: data.productId,
    title,
    intro: content,
    website: data.websiteUrl,
    companyName: data.companyName,
    pushIntro: `${content}\n ${data.websiteUrl}\n${data.companyName}`,
    siteIds: data.siteSelection,
    mediaIndustryIds: data.siteSelection.join(','),
    count: data.siteSelection.length || 0,
    flag: '',
    pushType: 1,
    postType,
    startPostTime: data.time,
    intervalTime: data.interval,
  }
}
export const handleForumPubForm = (data, { title, content }) => {
  let postType = data.pushType
  if (postType === 2 && data.interval) postType = 3
  if (!data.time) postType = 1
  return {
    sourceType: 2,
    type: data.productId,
    bbsType: data.productId,
    title,
    intro: content,
    website: data.websiteUrl,
    companyName: data.companyName,
    pushIntro: `${content}\n ${data.websiteUrl}\n${data.companyName}`,
    siteIds: data.siteSelection,
    mediaIndustryIds: data.siteSelection.join(','),
    count: data.siteSelection.length || 0,
    flag: '',
    pushType: 1,
    postType,
    startPostTime: data.time,
    intervalTime: data.interval,
  }
}
export const handleB2BPubForm = (data, { title, content }) => {
  const industry = data.industry || []
  let postType = data.pushType
  if (postType === 2 && data.interval) postType = 3
  if (!data.time) postType = 1
  return {
    sourceType: 2,
    industry,
    productType: [...industry].pop(),
    title,
    intro: content,
    summary: data.summary,
    images: data.images.map((item, ins) => {
      return { position: ins, src: item }
    }),
    website: data.websiteUrl,
    siteIds: data.siteSelection,
    pushType: 1,
    postType,
    startPostTime: data.time,
    intervalTime: data.interval,
  }
}

// 海外媒体发布（PR稿）：pubType 固定 20，mediaType 10=PR稿(海讯社/媒介易)
export const handleOverseasPubForm = (
  data,
  { title, content }: { title: string; content: string },
  activeArticle: any,
  mediaType: number,
) => {
  return {
    pubType: 20,
    geoFileId: activeArticle.fileId,
    pubCount: data.siteSelection.length || 0,
    content,
    pubParam: {
      Title: title,
      mediaIDList: data.siteSelection,
      MediaType: mediaType,
    },
  }
}
// Reddit 表单发布（A-6）：pubType 20 / pubCount 1，pubParam.form 为表单数据，固定扣点 400
export const handleRedditPubForm = (
  data,
  { title }: { title: string; content: string },
  activeArticle: any,
) => {
  return {
    pubType: 20,
    pubCount: 1,
    geoFileId: activeArticle.fileId,
    pubParam: {
      form: {
        ...data,
        Title: title,
      },
    },
  }
}

export const parseMediaData = (
  data: any,
  { title, content }: { title: string; content: string },
  activeArticle: any,
) => {
  const { mediaData, zxData, websiteData, prData, redditData } = data
  const { blogData, forumData, b2bData } = mediaData
  let blogForm = null
  let forumForm = null
  let b2bForm = null
  if (blogData) {
    blogForm = {
      pubType: 1,
      geoFileId: activeArticle.fileId,
      pubCount: blogData.siteSelection.length || 0,
      pubParam: handleBlogPubForm(blogData, { title, content }),
    }
  }
  if (forumData) {
    forumForm = {
      pubType: 2,
      geoFileId: activeArticle.fileId,
      pubCount: forumData.siteSelection.length || 0,
      pubParam: handleForumPubForm(forumData, { title, content }),
    }
  }
  if (b2bData) {
    b2bForm = {
      pubType: 3,
      geoFileId: activeArticle.fileId,
      pubCount: b2bData.siteSelection.length || 0,
      pubParam: handleB2BPubForm(b2bData, { title, content }),
    }
  }
  let zxForm = null
  if (zxData) {
    zxForm = {
      pubType: 10,
      geoFileId: activeArticle.fileId,
      pubCount: zxData.siteSelection.length || 0,
      content,
      pubParam: {
        MediaType: 10,
        productID: 46,
        Title: title,
        fileId: activeArticle.fileId,
        mediaIDList: zxData.siteSelection,
      },
    }
  }
  let websiteForm = null
  if (websiteData) {
    websiteForm = {
      pubType: 4,
      geoFileId: activeArticle.fileId,
      pubCount: 1,
      pubParam: {
        ...websiteData,
        content,
        title,
      },
    }
  }
  let prForm = null
  if (prData) {
    prForm = handleOverseasPubForm(prData, { title, content }, activeArticle, 10)
  }
  let redditForm = null
  if (redditData) {
    redditForm = handleRedditPubForm(redditData, { title, content }, activeArticle)
  }
  const formList = [
    { name: '发博客', id: 'blogForm', data: blogForm, rightNum: 2, isAllWrong: blogData === null },
    {
      name: '发论坛',
      id: 'forumForm',
      data: forumForm,
      rightNum: 2,
      isAllWrong: forumData === null,
    },
    { name: '发B2B', id: 'b2bForm', data: b2bForm, rightNum: 2, isAllWrong: b2bData === null },
    { name: '发臻选', id: 'zxForm', data: zxForm, rightNum: 30, isAllWrong: zxData === null },
    {
      name: '发官网',
      id: 'websiteForm',
      data: websiteForm,
      rightNum: 0,
      // == null 同时覆盖 null / undefined，避免官网表单未填或未挂载时仍出现“发官网”项
      isAllWrong: websiteData == null,
    },
    // pubTotal：按所选服务项 Price 动态求和的预计消耗，确认弹窗优先用它展示（缺省回退 rightNum × pubCount）
    {
      name: '发PR稿',
      id: 'prForm',
      data: prForm,
      rightNum: 30,
      pubTotal: prData?.pubTotal,
      isAllWrong: prData === null,
    },
    // Reddit 固定扣点 400，pubCount 恒为 1
    {
      name: '发Reddit',
      id: 'redditForm',
      data: redditForm,
      rightNum: 400,
      isAllWrong: redditData === null,
    },
  ]
  return { blogForm, forumForm, b2bForm, zxForm, websiteForm, prForm, redditForm, formList }
}
